"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const contextHeader_1 = require("./ts/enums/contextHeader");
const getProjectInfoByHost_1 = __importDefault(require("./client/getProjectInfoByHost"));
const hostname_1 = require("./utils/hostname");
const tool_1 = require("./utils/tool");
const headers = [
    { name: contextHeader_1.ContextHeader.TOOL_NAME, value: (0, tool_1.getTool)(window.location.hostname) },
    { name: contextHeader_1.ContextHeader.PROJECT_HOSTNAME, value: (0, hostname_1.getHostname)() },
];
let projectInfo;
function populateProjectHeaders() {
    return __awaiter(this, void 0, void 0, function* () {
        const MAX_ATTEMPTS = 2;
        const host = (0, hostname_1.getHostname)();
        for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
            try {
                projectInfo = yield (0, getProjectInfoByHost_1.default)(host);
            }
            catch (e) {
                console.error(`Error during getProjectInfoByHost - attempt ${attempt} -`, e);
            }
            if (projectInfo) {
                headers.push({ name: contextHeader_1.ContextHeader.PROJECT_ID, value: projectInfo.id }, { name: contextHeader_1.ContextHeader.PROJECT_NAME, value: projectInfo.displayName }, {
                    name: contextHeader_1.ContextHeader.PROJECT_AREA,
                    value: projectInfo.area || 'sales',
                }, {
                    name: contextHeader_1.ContextHeader.PROJECT_VENDOR,
                    value: projectInfo.feVendorKey || '',
                });
                break;
            }
        }
    });
}
function startXHRInjection(condition = () => true) {
    (function (open) {
        const isRegularXHR = open.toString().indexOf('native code') !== -1;
        // don't hijack if already hijacked - this will mess up with frameworks with zones
        if (isRegularXHR) {
            XMLHttpRequest.prototype.open = function (method, url, async, username, password) {
                if (condition(method, url, async, username, password)) {
                    headers.forEach((header) => this.setRequestHeader(header.name, header.value));
                    this.setRequestHeader(contextHeader_1.ContextHeader.TRANSACTION_ID, (0, uuid_1.v4)());
                }
                open.call(this, method, url, async, username, password);
            };
        }
    })(XMLHttpRequest.prototype.open);
}
function startFetchInjection(condition = () => true) {
    (function (fetch) {
        const isFetchNative = fetch.toString().indexOf('native code') !== -1;
        // don't hijack twice, if fetch is built with XHR no need to decorate, if already hijacked
        // then this is dangerous and we opt out
        if (isFetchNative) {
            window.fetch = function (url, options) {
                if (condition(url, options)) {
                    if (options === null || options === void 0 ? void 0 : options.headers) {
                        headers.forEach((header) => {
                            options.headers[header.name] = header.value;
                        });
                        options.headers[contextHeader_1.ContextHeader.TRANSACTION_ID] = (0, uuid_1.v4)();
                    }
                }
                return fetch.call(this, url, options);
            };
        }
    })(window.fetch || '');
}
/**
 * Inject context headers (tool information, project information, transaction id and session id)
 * into all requests routed to api.tecmasolutions.com, localhost or starting with / (proxy-pass)
 */
function injectContextHeaders() {
    populateProjectHeaders();
    const condition = (url) => {
        const stringUrl = url.toString();
        return ((stringUrl === null || stringUrl === void 0 ? void 0 : stringUrl.includes('api.tecmasolutions.com')) ||
            (stringUrl === null || stringUrl === void 0 ? void 0 : stringUrl.includes('localhost')) ||
            (stringUrl === null || stringUrl === void 0 ? void 0 : stringUrl.startsWith('/')) // proxy-pass
        );
    };
    startXHRInjection(condition);
    startFetchInjection(condition);
}
exports.default = injectContextHeaders;
